import React, { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import {
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Button,
  Row,
  Col,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
  Spinner,
  Card,
} from 'reactstrap';
import {
  week,
  month,
  last7Days,
  last30Days,
  last60Days,
  last90Days,
  LastDays,
  year,
} from './../lablesConfig';

import IntlMessages from '../../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import DatePicker from 'react-datepicker';
import 'moment-timezone';
import { API_Email_Stats } from '../../../../../../constants/APIs';
import EmailStatsAreaChart from './emailStatsAreaChart';
import EmailStatsPiChart from './emailStatsPiChart';
import EmailStatistics from './emailStatistics';
import EmailStatsTable from './emailStatsTable';

const today = () => {
  return moment(moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59')
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
};

const daysAgo7 = () => {
  return moment(moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const daysAgo30 = () => {
  return moment(moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const daysAgo60 = () => {
  return moment(moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const daysAgo90 = () => {
  return moment(moment().subtract(90, 'days').format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const startOfWeek = () => {
  const today = moment().subtract(1, 'days');
  return moment(moment(today).isoWeekday(1).format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const endOfWeek = () => {
  const today = moment().subtract(1, 'days');
  return moment(moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59')
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
};

const startOfMonth = () => {
  return moment(moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const startOfPreviousMonth = () => {
  return moment(
    moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
    ' 00:00:00'
  )
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
};

const startOfThisYear = () => {
  return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
    'YYYY-MM-DD HH:mm:ss'
  );
};

const startOfLastYear = () => {
  return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
    'YYYY-MM-DD HH:mm:ss'
  );
};
const endOfLastYear = () => {
  return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
    'YYYY-MM-DD HH:mm:ss'
  );
};

const endOfPreviousMonth = () => {
  return moment(
    moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
    ' 23:59:59'
  )
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
};

const endOfMonth = () => {
  return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
};

const topicsUsageColumns = [
  {
    Header: 'Topic',
    accessor: 'item',
    Cell: (props) => <p className="ml-2">{props.value}</p>,
  },
  {
    Header: 'Summaries',
    accessor: 'totalSummaries',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
  {
    Header: 'AI Replies',
    accessor: 'totalAiReplies',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
];

const emailUsgaeColumns = [
  {
    Header: 'Email',
    accessor: 'item',
    Cell: (props) => <p className="ml-2">{props.value}</p>,
  },
  {
    Header: 'Summaries',
    accessor: 'totalSummaries',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
  {
    Header: 'AI Replies',
    accessor: 'totalAiReplies',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
];

const EmailStats = ({ emailIntegrtions, propertyId, timeZone }) => {
  moment.tz.setDefault(timeZone);
  const [buttonText, setButtonText] = useState(
    <IntlMessages id="dashboards.last-7-days" />
  );
  const [labels, setLabels] = useState(last7Days);
  const [isShow, setIsShow] = useState(false);
  const [isError, setError] = useState(false);
  const [message, setMessage] = useState('');
  const [filterDate, setFilterDate] = useState(false);

  const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
  const [endDate, setEndDate] = useState(moment().subtract(1, 'days'));

  const [isThreadSummaryChartLoading, setIsThreadSummaryChartLoading] =
    useState(true);
  const [isAIRepliesChatLoading, setIsAIRepliesChatLoading] = useState(true);
  const [isEmailStatsCountLoading, setIsEmailStatsCountLoading] =
    useState(true);
  const [emailPiChartLoading, setEmailPiChartLoading] = useState(true);
  const [fromDate, setfromDate] = useState('');
  const [toDate, settoDate] = useState('');
  const [emailPiChartData, setEmailPiChartData] = useState();
  const [emailStatData, setEmailStatsData] = useState();
  const [emailStatsCount, setEmailStatsCount] = useState();
  const [threadSummaryData, setThreadSummaryData] = useState(null);
  const [aiRepliesData, setAiRepliesData] = useState(null);
  const [topicsUsageData, setTopicsUsageData] = useState(null);
  const [emailUsageData, setEmailUsageData] = useState(null);
  const [urgencyData, setUrgencyData] = useState(null);
  const [sentimentData, setSentimentData] = useState(null);
  const [summaryStats, setSummaryStats] = useState({
    totalThreadSummary: 0,
    totalAiReplies: 0,
    totalCopyDraft: 0,
  });

  const [errors, setErrors] = useState({
    threadSummary: null,
    aiReplies: null,
    topicsUsage: null,
    emailUsage: null,
    urgency: null,
    sentiment: null,
    stats: null,
  });

  const handleStartDate = (date) => setStartDate(moment(date));

  const handleEndDate = (date) => setEndDate(moment(date));

  const handleFilter = () => {
    let diff = endDate.diff(startDate, 'days');
    setButtonText('Date Range');
    if (diff > 365) {
      setMessage('The start and end date must be within a year of each other.');
      setError(true);
      return;
    }
    if (diff > 90) {
      setIsShow(false);
      setLabels(year);
      handleDateFilter(
        moment(startDate).format('YYYY-MM-DD 00:00:00'),
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59',
        true
      );
      setFilterDate(true);
    } else {
      if (diff >= 60) setLabels(LastDays(startDate, endDate));
      else if (diff >= 30) setLabels(LastDays(startDate, endDate));
      else if (diff >= 7) setLabels(LastDays(startDate, endDate));
      else setLabels(LastDays(startDate, endDate));
      setIsShow(false);
      handleDateFilter(
        moment(startDate).format('YYYY-MM-DD 00:00:00'),
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59',
        false
      );
      setFilterDate(true);
    }
  };

  const handleDateFilter = (startDate, endDate, isMonth) => {
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);

    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        dateFrom: startDate,
        dateTo: endDate,
        integrations:
          emailIntegrtions !== undefined && emailIntegrtions.length > 0
            ? emailIntegrtions.map((m) => m.id)
            : [],
        groupId: '73574010-2f33-4b41-8b8a-09d18b025a56',
        propertyId: 'e655dab2-987b-4683-ad9b-599814b414b6',
        isMonth: isMonth,
        dateFrom: startDate,
        dateTo: endDate,
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
      }
    });
  };
  const fetchEmailStats = ({ label, intlId, dateFrom, dateTo, isMonth }) => {
    setFilterDate(false);
    setButtonText(<IntlMessages id={intlId} />);
    setLabels(label);
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);
    setfromDate(dateFrom);
    settoDate(dateTo);

    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        integrations: emailIntegrtions?.length > 0 ? emailIntegrtions.map((m) => m.id) : [],
        isMonth,
        dateFrom,
        dateTo,
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
        fetchAllEmailStats(res.data);
      }
    });
  };

  const selectLast7Days = () =>
    fetchEmailStats({
      label: last7Days,
      intlId: 'dashboards.last-7-days',
      dateFrom: daysAgo7(),
      dateTo: today(),
      isMonth: false,
    });

  const selectLast30Days = () =>
    fetchEmailStats({
      label: last30Days,
      intlId: 'dashboards.last-30-days',
      dateFrom: daysAgo30(),
      dateTo: today(),
      isMonth: false,
    });

  const selectLast60Days = () =>
    fetchEmailStats({
      label: last60Days,
      intlId: 'dashboards.last-60-days',
      dateFrom: daysAgo60(),
      dateTo: today(),
      isMonth: false,
    });

  const selectLast90Days = () =>
    fetchEmailStats({
      label: last90Days,
      intlId: 'dashboards.last-90-days',
      dateFrom: daysAgo90(),
      dateTo: today(),
      isMonth: false,
    });

  const selectThisWeek = () =>
    fetchEmailStats({
      label: week,
      intlId: 'dashboards.this-week',
      dateFrom: startOfWeek(),
      dateTo: endOfWeek(),
      isMonth: false,
    });

  const selectThisMonth = () =>
    fetchEmailStats({
      label: month,
      intlId: 'dashboards.this-month',
      dateFrom: startOfMonth(),
      dateTo: endOfMonth(),
      isMonth: false,
    });

  const selectPreviousMonth = () =>
    fetchEmailStats({
      label: month,
      intlId: 'dashboards.previous-month',
      dateFrom: startOfPreviousMonth(),
      dateTo: endOfPreviousMonth(),
      isMonth: false,
    });

  const selectThisYear = () =>
    fetchEmailStats({
      label: year,
      intlId: 'dashboards.yeartodate',
      dateFrom: startOfThisYear(),
      dateTo: today(),
      isMonth: true,
    });

  const selectLastYear = () =>
    fetchEmailStats({
      label: year,
      intlId: 'dashboards.lastyear',
      dateFrom: startOfLastYear(),
      dateTo: endOfLastYear(),
      isMonth: true,
    });



  useEffect(() => {
    // console.log('emzil', emailIntegrtions)
    if (emailIntegrtions !== undefined) {
      selectLast7Days();

    }
  }, [propertyId]);
  const StatContainer = ({ onRefresh, error, children }) => {
    return (
      <div>
        {error ? (
          <Card className="text-center my-3" style={{ padding: '100px' }}>
            <p style={{ color: 'red' }}>{error}</p>

            <i className='iconsminds-refresh' style={{ fontSize: '40px', color: 'grey' }}
              onClick={onRefresh}
            />


          </Card>
        ) : (
          children
        )}
      </div>
    );
  };
  const fetchAllEmailStats = async (data) => {
    const updateError = (key, message) =>
      setErrors((prev) => ({ ...prev, [key]: message }));

    const clearError = (key) =>
      setErrors((prev) => ({ ...prev, [key]: null }));

    try {
      if (!data) return;

      // Thread Summary
      if (data?.threadSummaryChart) {
        setThreadSummaryData(data.threadSummaryChart);
        clearError('threadSummary');
      } else {
        updateError('threadSummary', 'Failed to load thread summary');
      }

      // AI Replies
      if (data?.aiRepliesChart) {
        setAiRepliesData(data.aiRepliesChart);
        clearError('aiReplies');
      } else {
        updateError('aiReplies', 'Failed to load AI replies');
      }

      // Topics Usage
      if (data?.topicsUsageInfo) {
        setTopicsUsageData(data.topicsUsageInfo);
        clearError('topicsUsage');
      } else {
        updateError('topicsUsage', 'Failed to load topics usage');
      }

      // Email Usage
      if (data?.emailUsageInfo) {
        setEmailUsageData(data.emailUsageInfo);
        clearError('emailUsage');
      } else {
        updateError('emailUsage', 'Failed to load email usage');
      }

      // Urgency
      if (data?.uregencyData) {
        setUrgencyData(data.uregencyData);
        clearError('urgency');
      } else {
        updateError('urgency', 'Failed to load urgency data');
      }

      // Sentiment
      if (data?.sentimentData) {
        setSentimentData(data.sentimentData);
        clearError('sentiment');
      } else {
        updateError('sentiment', 'Failed to load sentiment data');
      }

      // Summary Stats
      if (data?.totalThreadSummary !== undefined) {
        setSummaryStats({
          totalThreadSummary: data.totalThreadSummary,
          totalAiReplies: data.totalAiReplies,
          totalCopyDraft: data.totalCopyDraft,
        });
        clearError('stats');
      } else {
        updateError('stats', 'Failed to load summary stats');
      }
    } catch (error) {
      // fallback for unexpected failure
      setErrors({
        threadSummary: 'API call failed',
        aiReplies: 'API call failed',
        topicsUsage: 'API call failed',
        emailUsage: 'API call failed',
        urgency: 'API call failed',
        sentiment: 'API call failed',
        stats: 'API call failed',
      });
    }
  };
  return (
    <Fragment>
      <Row>
        <Col xxs="12" className="mb-2">
          <Fragment>
            {filterDate === true && (
              <div className="float-left mt-2">
                <span className="mr-2">
                  <b>From : </b>
                  {moment(startDate).format('DD')}/
                  {moment(startDate).format('MM')}/
                  {moment(startDate).format('YYYY')}
                </span>
                <span className="ml-2">
                  <b>To : </b>
                  {moment(endDate).format('DD')}/{moment(endDate).format('MM')}/
                  {moment(endDate).format('YYYY')}
                </span>
              </div>
            )}
            <div className="btn-group float-right float-none-xs mb-3">
              <UncontrolledDropdown>
                <DropdownToggle
                  caret
                  color="primary"
                  className="btn-xs"
                  outline
                >
                  {buttonText}
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem onClick={selectLast7Days}>
                    <IntlMessages id="dashboards.last-7-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast30Days}>
                    <IntlMessages id="dashboards.last-30-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast60Days}>
                    <IntlMessages id="dashboards.last-60-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast90Days}>
                    <IntlMessages id="dashboards.last-90-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisWeek}>
                    <IntlMessages id="dashboards.this-week" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisMonth}>
                    <IntlMessages id="dashboards.this-month" />
                  </DropdownItem>
                  <DropdownItem onClick={selectPreviousMonth}>
                    <IntlMessages id="dashboards.previous-month" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisYear}>
                    <IntlMessages id="dashboards.yeartodate" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLastYear}>
                    <IntlMessages id="dashboards.lastyear" />
                  </DropdownItem>
                  <DropdownItem onClick={() => setIsShow(!isShow)}>
                    <IntlMessages id="form-components.date-range" />
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </Fragment>
        </Col>
      </Row>
      <Row>
        <Col sm="12" md="6" className="mb-4">
          <StatContainer error={errors.threadSummary} onRefresh={() => fetchAllEmailStats(emailStatData)} >
            {threadSummaryData ? (
              <EmailStatsAreaChart
                labels={labels}
                title={'dashboards.thread-summary-title'}
                subtitle={'dashboards.thread-summary-subtitle'}
                data={threadSummaryData}
              />
            ) : (
              <div className="text-center">
                <div className="text-center loading" />
              </div>
            )}
          </StatContainer>
        </Col>
        <Col sm="12" md="6" className="mb-4">
          <StatContainer error={errors.aiReplies} onRefresh={() => fetchAllEmailStats(emailStatData)} >
            {aiRepliesData ? (
              <EmailStatsAreaChart
                labels={labels}
                data={aiRepliesData}
                title={'dashboards.ai-replies-title'}
                subtitle={'dashboards.ai-replies-subtitle'}
              />

            ) : (
              <div className="text-center">
                <div className="text-center loading" />
              </div>
            )}
          </StatContainer>
        </Col>
      </Row>
      <Row>
        <Col sm="12" md="6" className="mb-4">
          <StatContainer error={errors.topicsUsage} onRefresh={() => fetchAllEmailStats(emailStatData)} >
            {topicsUsageData ? (
              <EmailStatsTable
                labels={topicsUsageColumns}
                data={topicsUsageData}
                title={'dashboards.common-email-reasons'}
                subtitle={'dashboards.topics-in-emails'}
              />
            ) : (
              <div className="text-center">
                <div className="text-center loading" />
              </div>
            )}
          </StatContainer>
          {/* {emailStatData?.topicsUsageInfo ? (
            <EmailStatsTable
              labels={topicsUsageColumns}
              data={emailStatData?.topicsUsageInfo}
              title={'dashboards.common-email-reasons'}
              subtitle={'dashboards.topics-in-emails'}
            />
          ) : (
            <div className="text-center">
              <div className="text-center loading" />
            </div>
          )} */}
        </Col>
        <Col sm="12" md="6" className="mb-4">
          <StatContainer error={errors.emailUsage} onRefresh={() => fetchAllEmailStats(emailStatData)} >
            {emailUsageData ? (
              <EmailStatsTable
                labels={emailUsgaeColumns}
                data={emailUsageData}
                title={'dashboards.email-assistant-usage'}
                subtitle={'dashboards.usage-by-email-address'}
              />
            ) : (
              <div className="text-center">
                <div className="text-center loading" />
              </div>
            )}
          </StatContainer>
        </Col>
      </Row>
      <Row>
        <Col sm="12" md="3" className="mb-4">
          <StatContainer error={errors.urgency} onRefresh={() => fetchAllEmailStats(emailStatData)} >
            {urgencyData ? (
              <EmailStatsPiChart
                labels={['High', 'Medium', 'Low']}
                title={'dashboards.urgency'}
                subtitle={''}
                data={urgencyData}
              />
            ) : (
              <div className="text-center">
                <div className="text-center loading" />
              </div>
            )}
          </StatContainer>
        </Col>
        <Col sm="12" md="3" className="mb-4">
          <StatContainer error={errors.sentiment} onRefresh={() => fetchAllEmailStats(emailStatData)} >
            {sentimentData ? (
              <EmailStatsPiChart
                title={'dashboards.sentiment'}
                subtitle={''}
                labels={['Negative', 'Neutral', 'Positive']}
                data={sentimentData}
              />
            ) : (
              <div className="text-center">
                <div className="text-center loading" />
              </div>
            )}
          </StatContainer>
        </Col>
        <Col sm="12" md="6" className="mb-4">
          <StatContainer error={errors.stats} onRefresh={() => fetchAllEmailStats(emailStatData)} >
            <div className="iconcards-row row d-flex">
              <EmailStatistics
                name={'Summary'}
                title={'dashboards.total-thread-summary-title'}
                count={summaryStats.totalThreadSummary || 0}
                icon=""
              />
              <EmailStatistics
                name={'Replies'}
                title={'dashboards.total-ai-replies-title'}
                count={summaryStats.totalAiReplies || 0}
                icon=""
              />
              <EmailStatistics
                name={'Copied'}
                title={'dashboards.total-draft-copied'}
                count={summaryStats.totalCopyDraft || 0}
                icon=""
              />
              <EmailStatistics
                name={'dashboards.minutes'}
                title={'dashboards.number-estimatedtimesaving'}
                count={
                  (summaryStats.totalThreadSummary || 0) * 0.5 +
                  (summaryStats.totalAiReplies || 0) * 5
                }
                icon="iconsminds-clock"
              />
            </div>
          </StatContainer>
        </Col>

        {/* <Col sm="12" md="6" className="mb-4">
          <div className="iconcards-row row d-flex">
            <EmailStatistics
              name={'Summary'}
              title={'dashboards.total-thread-summary-title'}
              count={
                emailStatData?.totalThreadSummary
                  ? emailStatData.totalThreadSummary
                  : 0
              }
              icon={""}
            />
            <EmailStatistics
              name={'Replies'}
              title={'dashboards.total-ai-replies-title'}
              count={
                emailStatData?.totalAiReplies ? emailStatData.totalAiReplies : 0
              }
              icon={""}
            />
            <EmailStatistics
              name={'Copied'}
              title={'dashboards.total-draft-copied'}
              count={
                emailStatData?.totalCopyDraft ? emailStatData.totalCopyDraft : 0
              }
              icon={""}
            />
            <EmailStatistics
              name={'dashboards.minutes'}
              title={'dashboards.number-estimatedtimesaving'}
              count={
                (emailStatData?.totalThreadSummary ? emailStatData.totalThreadSummary * 0.5 : 0) +
                (emailStatData?.totalAiReplies ? emailStatData.totalAiReplies * 5 : 0)
              }
              icon={'iconsminds-clock'}
            />
          </div>
        </Col> */}
      </Row>

      <Modal
        isOpen={isShow}
        toggle={() => setIsShow(!isShow)}
        style={{ borderRadius: '10px' }}
      >
        <ModalHeader toggle={() => setIsShow(!isShow)}>Date Range</ModalHeader>
        <ModalBody>
          <Row>
            <Colxx md="4" className="mb-2">
              <FormGroup>
                <Label><IntlMessages id='dashboards.start-date' /></Label>
                <DatePicker
                  style={{ borderRadius: "10px" }}
                  selected={startDate ? new Date(startDate) : null} // ensure Date object
                  onChange={handleStartDate}
                  placeholderText="Start Date"
                  dateFormat="dd/MM/yyyy"   // ✅ correct format
                />
              </FormGroup>
            </Colxx>

            <Colxx md="4" className="mb-2">
              <FormGroup>
                <Label> <IntlMessages id='dashboards.end-date' /></Label>
                <DatePicker
                  style={{ borderRadius: "10px" }}
                  selected={endDate ? new Date(endDate) : null} // ✅ always Date object
                  onChange={handleEndDate}
                  placeholderText="End Date"
                  dateFormat="dd/MM/yyyy"   // ✅ correct format
                />
              </FormGroup>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleFilter()}>
            Submit
          </Button>
          <Button className="ml-2" onClick={() => setIsShow(!isShow)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};
export default EmailStats;
